import { RoleAccount } from '@/components/role-account';

export default function StudentAccountScreen() {
  return <RoleAccount accent="#1F5A37" roleLabel="Student" />;
}
